import { useQuery, type QueryKey } from "@tanstack/react-query";
import { useAuth } from "../app/auth";

export function useApiQuery<T>(
  key: QueryKey,
  path: string,
  options?: {
    enabled?: boolean;
    refetchInterval?: number | false;
  },
) {
  const { request } = useAuth();
  return useQuery({
    queryKey: key,
    queryFn: () => request<T>(path),
    enabled: options?.enabled,
    refetchInterval: options?.refetchInterval,
  });
}
